import React, {useEffect, ReactElement} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Pageable} from '@deviceinsight/ng-ui-api-client';
import {deleteRule} from '../../../api/ruleApi';
import type {Rule} from '../../../modules/ruleengine/types';
import type {SearchSettings} from '../ruleListeHelpers';
import {TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';

const getNextPageAfterDeletion = (rules: Array<Rule>, currentPage: number) => {
	if (rules.length === 1 && currentPage > 0) {
		return currentPage - 1;
	} else {
		return currentPage;
	}
};

const useDeleteRule = (
	ruleToDelete: Rule | null | undefined,
	setRuleToDelete: (arg0: Rule | null | undefined) => void,
	searchSettings: SearchSettings,
	setSearchSettings: (arg0: SearchSettings) => void,
	confirm: (
		title: TranslationDescriptor,
		message: ReactElement<any, any>,
		acceptButtonLabel?: TranslationDescriptor,
		declineButtonLabel?: TranslationDescriptor,
		resolveWithConfirmation?: boolean
	) => Promise<boolean | void>,
	rules: Pageable<Rule>
) => {
	useEffect(() => {
		if (ruleToDelete) {
			confirm(
				{
					id: 'ruleengine.list.delete.deleteConfirmTitle',
					defaultValue: 'Delete rule'
				},
				<Trans
					i18nKey="ruleengine.list.delete.deleteConfirmMessage"
					values={{
						ruleName: ruleToDelete.name
					}}>
					<>
						Do you want to delete the rule{' '}
						{{
							ruleName: ruleToDelete.name
						}}
						? This cannot be reverted.
					</>
				</Trans>,
				undefined,
				undefined,
				true
			).then((isConfirmed) => {
				if (ruleToDelete.id && isConfirmed) {
					const nextPage = getNextPageAfterDeletion(rules.content, searchSettings.paginationSettings.page);
					deleteRule(ruleToDelete.id, ruleToDelete.assetGroupId).then(() => {
						setSearchSettings({
							...searchSettings,
							paginationSettings: {...searchSettings.paginationSettings, page: nextPage}
						});
					});
				} else {
					setRuleToDelete(undefined);
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ruleToDelete]);
};

export default useDeleteRule;
